import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import PaymentPage from 'views/payment-page';

// sample page routing
const WorkspacePage = Loadable(lazy(() => import('views/workspace-page')));
const WorkplacePage = Loadable(lazy(() => import('views/workplace-page')));
const ReviewPage = Loadable(lazy(() => import('views/review-page')));
const OldSettingPage = Loadable(lazy(() => import('views/old-setting-page')));
const AccountSettingPage = Loadable(lazy(() => import('views/account-setting-page')));
const WorkspaceSettingPage = Loadable(lazy(() => import('views/workspace-setting-page')));
const MemberPage = Loadable(lazy(() => import('views/member-page')));
const BillingPage = Loadable(lazy(() => import('views/billing-page')));
const CampaignDetailPage = Loadable(lazy(() => import('views/campaign-detail-page')));
const CampaignPage = Loadable(lazy(() => import('views/campaign-page')));
const PageNotFound = Loadable(lazy(() => import('views/page-not-found')));
const ExpiredPage = Loadable(lazy(() => import('views/expired-page')));
const SmartCreatorPage = Loadable(lazy(() => import('views/smart-creator-page')));
const CreatorTypePage = Loadable(lazy(() => import('views/smart-creator-select-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <NavigationScroll>
            <AuthGuard>
                <MainLayout />
            </AuthGuard>
        </NavigationScroll>
    ),
    children: [
        {
            path: '/w/:workspaceId',
            element: <WorkspacePage />
        },
        {
            path: '/w/:workspaceId/expired',
            element: <ExpiredPage />
        },
        {
            path: '/w/:workspaceId/p/:projectId',
            element: <WorkplacePage />
        },
        {
            path: '/review/:type/:id',
            element: <ReviewPage />
        },
        {
            path: '/setting',
            element: <OldSettingPage />
        },
        {
            path: '/w/:workspaceId/account-setting',
            element: <AccountSettingPage />
        },
        {
            path: '/w/:workspaceId/workspace-setting',
            element: <WorkspaceSettingPage />
        },
        {
            path: '/w/:workspaceId/member',
            element: <MemberPage />
        },
        {
            path: '/w/:workspaceId/billing',
            element: <BillingPage />
        },
        {
            path: '/w/:workspaceId/payment/:orderId',
            element: <PaymentPage />
        },
        {
            path: '/w/:workspaceId/p/:projectId/c-d/:id',
            element: <CampaignDetailPage />
        },
        {
            path: '/w/:workspaceId/p/:projectId/c/:id',
            element: <CampaignPage />
        },
        {
            path: '/w/:workspaceId/creator',
            element: <SmartCreatorPage />
        },
        {
            path: '/w/:workspaceId/creator/type',
            element: <CreatorTypePage />
        }
    ]
};

export default MainRoutes;
